export default __webpack_public_path__ + "static/media/homepage_step_2.9c308397.svg";